<template>
  <div class="contenBox">
    <!-- 左侧欢迎语 -->
    <div class="describe">
      <div class="top">
        <div>{{ enterName }}</div>
        <!-- <div>您好！祝您开心每一天</div> -->
      </div>
      <div class="bottom">
        <div>登录于：{{ this.currentTime }}</div>
        <div @click="edit" v-if="flag">编辑</div>
      </div>
    </div>
    <!-- 企业中心or机构中心logo -->
    <div :class="flag ? 'logo' : 'logo2'"></div>
  </div>
</template>

<script>
import { handleDate } from '@/utils/index'
import { mapGetters } from 'vuex'
export default {
  props: ['flag'],
  computed: {
    ...mapGetters(['enterName'])
  },
  data() {
    return {
      currentTime: '' // 存储当前时间
    }
  },
  created() {
    // 获取当前时间并格式化
    this.currentTime = handleDate()
  },
  methods: {
    // 编辑功能
    edit() {
      if (this.flag) {
        // 跳转到企业账户信息管理
        this.$router.push('/enterprise/accountInformation')
      } else {
        // 机构
        this.$router.push('/mechanism/mechanismInfomation')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 欢迎容器
.contenBox {
  position: relative;
  width: 100%;
  height: 120px;
  background-image: url('~@/assets/images/welcome.png');
  background-size: cover; /* 确保图片覆盖整个元素 */
  background-position: center; /* 将图片居中显示 */

  .logo {
    width: 211px;
    height: 43px;
    background-image: url('~@/assets/images/enterpicture.png');
    position: absolute;
    top: 35%;
    right: 25%;
  }
  .logo2 {
    width: 211px;
    height: 43px;
    background-image: url('~@/assets/images/mechanism.png');
    position: absolute;
    top: 35%;
    right: 25%;
  }
  .describe {
    height: 100%;
    position: absolute;
    top: 25%;
    left: 12%;
    .top {
      display: flex;
      :nth-child(1) {
        font-weight: 500;
        min-width: 120px;
        height: 23px;
        font-size: 24px;
        color: #ffffff;
      }
      :nth-child(2) {
        font-weight: 400;
        width: 240px;
        height: 23px;
        font-size: 24px;
        color: #ffffff;
        margin-left: 41px;
      }
    }
    .bottom {
      display: flex;
      margin-top: 20px;
      :nth-child(1) {
        font-weight: 400;
        width: 320px;
        height: 19px;
        font-size: 20px;
        color: #ffffff;
      }
      :nth-child(2) {
        width: 70px;
        height: 28px;
        line-height: 28px;
        border-radius: 5px 5px 5px 5px;
        opacity: 0.5;
        margin-left: 20px;
        background: #ffffff;
        color: #006dfb;
        cursor: pointer;
        margin-left: 18px;
        text-align: center;
      }
    }
  }
}
</style>
